import { SVGInterface } from "../../interface";

const CircleCloseFilled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.76183 15.832C4.31066 19.5703 7.95972 22.0068 12.0062 22.0044C14.6603 22.013 17.2076 20.9594 19.0802 19.0784C21.6075 16.5511 22.5945 12.8675 21.6694 9.41511C20.7444 5.96276 18.0478 3.26617 14.5954 2.34111C11.1431 1.41606 7.45946 2.40308 4.93216 4.93037C2.0697 7.79046 1.213 12.0937 2.76183 15.832ZM9.41524 16.0043L12.0063 13.4145L14.5972 16.0043L16.0063 14.5944L13.4163 12.0044L16.0063 9.41439L14.5963 8.00439L12.0063 10.5944L9.41635 8.00439L8.00635 9.41439L10.5963 12.0044L8.00635 14.5944L9.41524 16.0043Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CircleCloseFilled;
